module.exports = __webpack_public_path__ + "img/gune_3.66fa1886.jpg";